import React, { useEffect, useState, useRef, useCallback } from "react";
import { getCategorias } from "../api";
import { toast } from "react-hot-toast";

const BottomSheetCategorias = ({ onClose, onAplicar, categoriaActual, onQuitarFiltro }) => {
  const [categorias, setCategorias] = useState([]);
  const [idSeleccionada, setIdSeleccionada] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const observer = useRef();

  const cargarCategorias = async (pageToLoad = 1) => {
    if (loading || !hasMore) return;
    setLoading(true);
    try {
      const res = await getCategorias(pageToLoad);
      if (res.success && res.categorias.length > 0) {
        setCategorias((prev) => {
          const todos = pageToLoad === 1 ? res.categorias : [...prev, ...res.categorias];
          const unicos = Array.from(new Map(todos.map((c) => [c.id, c])).values());
          return unicos;
        });
        if (res.categorias.length < 30) {
          setHasMore(false);
        } else {
          setPage(pageToLoad + 1);
        }
      } else {
        setHasMore(false);
      }
    } catch (err) {
    }
    setLoading(false);
  };

  const lastCatRef = useCallback(
    (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          cargarCategorias(page);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, hasMore, page]
  );

  // Al montar el componente (abrir modal), reiniciar todo y cargar
  useEffect(() => {
    setCategorias([]);
    setPage(1);
    setHasMore(true);
    cargarCategorias(1);
  }, []);

  return (
    <div className="bottom-sheet-overlay">
      <div className="bottom-sheet-categorias">
        <div className="header">
          <h3 style={{fontSize:18, fontWeight: "bold", marginBottom:0}}>Categorías</h3>
          <button onClick={onClose} style={{background: "white"}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24"><path fill="#d3d3d3" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"></path></svg>
          </button>
        </div>

        <div className="contenido" style={{ maxHeight: "60vh", overflowY: "auto" }}>
          {categorias.map((cat, i) => (
            <div
              key={cat.id}
              ref={i === categorias.length - 1 ? lastCatRef : null}
              className={`categoria-item ${cat.id === idSeleccionada ? "seleccionada" : ""}`}
              onClick={() => setIdSeleccionada(cat.id)}
            >
              {cat.nombre}
            </div>
          ))}
          {loading && (
            <div style={{ textAlign: "center", padding: "10px" }}>
              <div className="custom-spinner"></div>
            </div>
          )}
        </div>

        <div className="acciones">
          <button
            className="btn-aplicar"
            onClick={() => {
              if (idSeleccionada) {
                toast.dismiss();
                onAplicar(idSeleccionada);
                onClose();
              } else {
                toast.dismiss();
                toast.error("Selecciona una categoría primero");
              }
            }}
          >
            Aplicar filtro
          </button>

          {categoriaActual && (
            <div style={{ padding: "10px 15px", textAlign: "center" }}>
              <button
                onClick={() => {
                  toast.dismiss();
                  onQuitarFiltro();
                  onClose();
                }}
                style={{
                  marginLeft: "10px",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  border: "none",
                  fontWeight: "bold",
                  background: "white",
                  color: "#e30000",
                  cursor: "pointer",
                }}
              >
                Quitar filtro
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BottomSheetCategorias;
